export type Source = {
  library: string
  os_license: string
  license_name: string
}

export const sources: Source[] = [
  {
    library: '@emotion/react',
    os_license: 'https://github.com/emotion-js/emotion/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@emotion/styled',
    os_license: 'https://github.com/emotion-js/emotion/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@firebase/analytics',
    os_license:
      'https://github.com/firebase/firebase-js-sdk/blob/master/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: '@firebase/app',
    os_license:
      'https://github.com/firebase/firebase-js-sdk/blob/master/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: '@firebase/remote-config',
    os_license:
      'https://github.com/firebase/firebase-js-sdk/blob/master/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: '@mui/icons-material',
    os_license: 'https://github.com/mui/material-ui/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@mui/lab',
    os_license: 'https://github.com/mui/material-ui/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@mui/material',
    os_license: 'https://github.com/mui/material-ui/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@mui/styles',
    os_license: 'https://github.com/mui/material-ui/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@mui/x-license',
    os_license:
      'https://github.com/mui/mui-x/blob/master/packages/x-license/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@mui/x-date-pickers',
    os_license: 'https://github.com/mui/material-ui/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@nivo/bar',
    os_license: 'https://github.com/plouc/nivo/blob/master/LICENSE.md',
    license_name: 'MIT',
  },
  {
    library: '@nivo/core',
    os_license: 'https://github.com/plouc/nivo/blob/master/LICENSE.md',
    license_name: 'MIT',
  },
  {
    library: '@react-spring/web',
    os_license: 'https://github.com/pmndrs/react-spring/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@sentry/react',
    os_license:
      'https://github.com/getsentry/sentry-javascript/blob/develop/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@tanstack/react-query-devtools',
    os_license: 'https://github.com/TanStack/query/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@tanstack/react-query',
    os_license: 'https://github.com/TanStack/query/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@testing-library/jest-dom',
    os_license: 'https://github.com/testing-library/jest-dom/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@testing-library/react',
    os_license:
      'https://github.com/testing-library/react-testing-library/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@testing-library/user-event',
    os_license:
      'https://github.com/testing-library/user-event/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@turf/boolean-intersects',
    os_license:
      'https://github.com/Turfjs/turf/blob/master/packages/turf-boolean-intersects/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@turf/helpers',
    os_license:
      'https://github.com/Turfjs/turf/blob/master/packages/turf-helpers/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@types/lodash.debounce',
    os_license:
      'https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@types/lodash',
    os_license:
      'https://github.com/DefinitelyTyped/DefinitelyTyped/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: '@use-gesture/react',
    os_license:
      'https://github.com/unicef/material-ui-currency-textfield/blob/master/README.md#license',
    license_name: 'MIT',
  },
  {
    library: 'absl-py',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'actions/checkout',
    os_license: 'https://github.com/actions/checkout/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'actions/github-script',
    os_license: 'https://github.com/actions/github-script/blob/main/LICENSE.md',
    license_name: 'MIT',
  },
  {
    library: 'actions/setup-node',
    os_license: 'https://github.com/actions/setup-node/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'apispec',
    os_license: 'https://apispec.readthedocs.io/en/latest/license.html',
    license_name: 'MIT',
  },
  {
    library: 'apispec-webframeworks',
    os_license:
      'https://github.com/marshmallow-code/apispec-webframeworks/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'appdirs',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'argparse',
    os_license:
      'https://en.wikipedia.org/wiki/Python_Software_Foundation_License',
    license_name: 'PSF',
  },
  {
    library: 'array-move',
    os_license: 'https://github.com/sindresorhus/array-move/blob/main/license',
    license_name: 'MIT',
  },
  {
    library: 'asgiref',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'astor',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'attrs',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'aws-actions/amazon-ecr-login',
    os_license:
      'https://github.com/aws-actions/configure-aws-credentials/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'aws-amplify',
    os_license: 'https://github.com/aws-amplify/amplify-js/blob/main/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: 'axios',
    os_license: 'https://github.com/axios/axios/blob/HEAD/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'black',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'boto3',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'botocore',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'buffer',
    os_license: 'https://github.com/feross/buffer/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'cached-property',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'certifi',
    os_license: 'https://github.com/certifi/python-certifi/blob/master/LICENSE',
    license_name: 'CA Bundle',
  },
  {
    library: 'cfgv',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'chardet',
    os_license: 'https://www.gnu.org/licenses/gpl-3.0.en.html',
    license_name: 'GNU',
  },
  {
    library: 'charset-normalizer',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'chetan/invalidate-cloudfront-action',
    os_license:
      'https://github.com/chetan/invalidate-cloudfront-action/blob/develop/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'click ',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'color',
    os_license: 'https://github.com/Qix-/color/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'cropperjs',
    os_license: 'https://github.com/fengyuanchen/cropperjs/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'cryptography',
    os_license: 'https://github.com/pyca/cryptography/blob/main/LICENSE',
    license_name: 'Apache 2.0/BSD',
  },
  {
    library: 'Cython',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'd3-scale',
    os_license: 'https://github.com/d3/d3-scale/blob/main/LICENSE',
    license_name: 'ISC',
  },
  {
    library: 'dataclasses',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'date-fns',
    os_license: 'https://github.com/date-fns/date-fns/blob/main/LICENSE.md',
    license_name: 'MIT',
  },
  {
    library: 'DateTime',
    os_license: 'https://spdx.org/licenses/ZPL-2.1.html',
    license_name: 'ZPL 2.1',
  },
  {
    library: 'dayjs',
    os_license: 'https://github.com/iamkun/dayjs/blob/dev/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'deepdiff',
    os_license: 'https://github.com/seperman/deepdiff/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'distlib',
    os_license: 'https://spdx.org/licenses/PSF-2.0.html',
    license_name: 'SPDX 2.0',
  },
  {
    library: 'Django',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'filelock',
    os_license: 'https://unlicense.org',
    license_name: 'Unlicense',
  },
  {
    library: 'flak38',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'Flask',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'flask-classful',
    os_license:
      'https://github.com/teracyhq/flask-classful/blob/develop/LICENSE',
    license_name: 'BSD-3',
  },
  {
    library: 'Flask-Cors',
    os_license: 'https://github.com/corydolphin/flask-cors/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'flask-jwt-extended',
    os_license:
      'https://github.com/vimalloc/flask-jwt-extended/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'Flask-Login',
    os_license: 'https://opensource.org/search/node/MIT',
    license_name: 'MIT',
  },
  {
    library: 'Flask-Mail',
    os_license: 'https://github.com/mattupstate/flask-mail/blob/master/LICENSE',
    license_name: 'BSD-3',
  },
  {
    library: 'flask-marshmallow',
    os_license:
      'https://github.com/marshmallow-code/flask-marshmallow/blob/dev/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'Flask-Principal',
    os_license:
      'https://github.com/mattupstate/flask-principal/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'Flask-SQLAlchemy',
    os_license:
      'https://github.com/pallets-eco/flask-sqlalchemy/blob/main/LICENSE.rst',
    license_name: 'BSD-3',
  },
  {
    library: 'Flask-WTF',
    os_license: 'https://flask-wtf.readthedocs.io/en/0.15.x/license/',
    license_name: 'BSD-3',
  },
  {
    library: 'future',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'fuzzywuzzy',
    os_license: 'https://www.gnu.org/licenses/old-licenses/gpl-2.0.en.html',
    license_name: 'GPL 2.0',
  },
  {
    library: 'gast',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'git+ssh',
    os_license: 'https://github.com/gliderlabs/ssh/blob/master/LICENSE',
    license_name: 'BSD-3',
  },
  {
    library: 'google',
    os_license: '',
    license_name: '',
  },
  {
    library: 'google-api-python-client',
    os_license:
      'https://github.com/googleapis/google-api-python-client/blob/main/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: 'google-pasta',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'grpcio',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'gunicorn',
    os_license: 'https://github.com/benoitc/gunicorn/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'hashicorp/setup-terraform',
    os_license:
      'https://github.com/hashicorp/setup-terraform/blob/main/LICENSE',
    license_name: 'Mozilla 2.0',
  },
  {
    library: 'hdf5',
    os_license:
      'https://en.wikipedia.org/wiki/Python_Software_Foundation_License',
    license_name: 'PSF',
  },
  {
    library: 'id128',
    os_license: 'https://github.com/aarondcohen/id128/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'identify',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'idna',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'image',
    os_license: 'https://opensource.org/licenses/HPND',
    license_name: 'HPND',
  },
  {
    library: 'importlib-metadata',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'importlib-resources',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'inflect',
    os_license: 'https://github.com/markbates/inflect/blob/master/LICENCE',
    license_name: 'MIT',
  },
  {
    library: 'inflection',
    os_license:
      'https://github.com/SwiftDocOrg/Inflection/blob/main/LICENSE.md',
    license_name: 'MIT',
  },
  {
    library: 'intuit-oauth',
    os_license: 'https://github.com/intuit/oauth-jsclient/blob/master/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: 'isort',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'jakejarvis/s3-sync-action',
    os_license:
      'https://github.com/jakejarvis/s3-sync-action/blob/master/LICENSE.md',
    license_name: 'MIT',
  },
  {
    library: 'jmespath',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'joblib',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'Keras',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'Keras-Applications',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'Keras-Preprocessing',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'lodash.clonedeep',
    os_license:
      'https://github.com/lodash/lodash/blob/npm-packages/lodash.clonedeep/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'lodash.debounce',
    os_license:
      'https://github.com/lodash/lodash/blob/npm-packages/lodash.debounce/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'lodash.set',
    os_license:
      'https://github.com/lodash/lodash/blob/npm-packages/lodash.set/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'lxml',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'ManagedKube',
    os_license:
      'https://github.com/ManagedKube/kubernetes-ops/blob/main/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: 'markdown',
    os_license:
      'https://github.com/Python-Markdown/markdown/blob/master/LICENSE.md',
    license_name: 'TMP',
  },
  {
    library: 'marshmallow',
    os_license:
      'https://github.com/marshmallow-code/marshmallow/blob/dev/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'marshmallow-sqlalchemy',
    os_license:
      'https://github.com/marshmallow-code/marshmallow-sqlalchemy/blob/dev/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'material-react-table',
    os_license:
      'https://github.com/KevinVandy/material-react-table/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'mccabe',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'mysql-connector-python',
    os_license: 'https://www.gnu.org/licenses/old-licenses/gpl-2.0.en.html',
    license_name: 'GNU 2.0',
  },
  {
    library: 'nodeenv',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'notistack',
    os_license:
      'https://github.com/iamhosseindhv/notistack/blob/master/LICENSE.md',
    license_name: 'MIT',
  },
  {
    library: 'numpy',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'opencv-python',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'opensearch-py',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'opt-einsum',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'pandas',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'pathspec',
    os_license: 'https://www.mozilla.org/en-US/MPL/2.0/',
    license_name: 'MPL 2.0',
  },
  {
    library: 'phonenumbers',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'Pillow',
    os_license: 'https://opensource.org/licenses/HPND',
    license_name: 'HPND',
  },
  {
    library: 'pip',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'point-in-polygon',
    os_license:
      'https://github.com/substack/point-in-polygon/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'pre-commit',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'protobuf',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'psutil',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'psycopg2-binary',
    os_license: 'https://www.psycopg.org/license/',
    license_name: 'GNU',
  },
  {
    library: 'pycodestyle',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'pyflakes',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'PyJWT',
    os_license: 'https://github.com/jpadilla/pyjwt/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'PyMuPDF',
    os_license: 'https://www.gnu.org/licenses/agpl-3.0.en.html',
    license_name: 'AGPL',
  },
  {
    library: 'PyPDF2',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'pytesseract',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'pytest',
    os_license: 'https://github.com/pytest-dev/pytest/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'pytest-mock',
    os_license: 'https://github.com/pytest-dev/pytest-mock/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'python-dateutil',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'python-jose',
    os_license: 'https://github.com/mpdavis/python-jose/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'python-quickbooks',
    os_license: 'https://github.com/ej2/python-quickbooks/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'pytz',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'PyYAML',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'react',
    os_license: 'https://github.com/facebook/react/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'react-cropper',
    os_license:
      'https://github.com/react-cropper/react-cropper/blob/develop/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'react-dom',
    os_license: 'https://github.com/facebook/react/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'react-error-boundary',
    os_license:
      'https://github.com/bvaughn/react-error-boundary/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'react-helmet',
    os_license: 'https://github.com/nfl/react-helmet/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'react-hook-form',
    os_license:
      'https://github.com/react-hook-form/react-hook-form/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'react-hotkeys-hook',
    os_license:
      'https://github.com/JohannesKlauss/react-hotkeys-hook/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'react-number-format',
    os_license:
      'https://github.com/s-yadav/react-number-format/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'react-router-dom',
    os_license:
      'https://github.com/remix-run/react-router/blob/main/LICENSE.md',
    license_name: 'MIT',
  },
  {
    library: 'react-scripts',
    os_license:
      'https://github.com/facebook/create-react-app/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'react-smooth-dnd',
    os_license:
      'https://github.com/kutlugsahin/react-smooth-dnd/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'react-zoom-pan-pinch',
    os_license:
      'https://github.com/prc5/react-zoom-pan-pinch/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'regex',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'requests',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'requests-aws4auth',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 's3transfer',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'sacremoses',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'scipy',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'sentencepiece',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'sentry-sdk',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'seqeval',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'setuptools',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'simplejson',
    os_license:
      'https://github.com/simplejson/simplejson/blob/master/LICENSE.txt',
    license_name: 'MIT/Academic Free',
  },
  {
    library: 'six',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'spicy',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'split-pane-react',
    os_license: 'https://github.com/yyllff/split-pane-react/blob/main/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'SQLAlchemy',
    os_license: 'https://github.com/zzzeek/sqlalchemy/blob/master/LICENSE',
    license_name: 'MIT',
  },
  {
    library: 'SQLAlchemy-Utils',
    os_license:
      'https://github.com/kvesteri/sqlalchemy-utils/blob/master/LICENSE',
    license_name: 'BSD-3',
  },
  {
    library: 'sqlparse',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'tensorboard',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'tensorboardX',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'tensorflow',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'tensorflow-estimator',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'termcolor',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'tokenizers',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'toml',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'torch',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'tqdm',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'transformers',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'typed-ast',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'typescript',
    os_license: 'https://github.com/microsoft/TypeScript/blob/main/LICENSE.txt',
    license_name: 'Apache 2.0',
  },
  {
    library: 'typing-extensions',
    os_license:
      'https://en.wikipedia.org/wiki/Python_Software_Foundation_License',
    license_name: 'PSF',
  },
  {
    library: 'Unilm',
    os_license: 'http://www.apache.org/licenses/LICENSE-2.0',
    license_name: 'Apache 2.0',
  },
  {
    library: 'urllib3',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'virtualenv',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'web-vitals',
    os_license: 'https://github.com/GoogleChrome/web-vitals/blob/HEAD/LICENSE',
    license_name: 'Apache 2.0',
  },
  {
    library: 'Werkzeug',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'wheel',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'wrapt',
    os_license: 'https://opensource.org/licenses/BSD-3-Clause',
    license_name: 'BSD-3',
  },
  {
    library: 'zipp',
    os_license: 'https://opensource.org/licenses/MIT',
    license_name: 'MIT',
  },
  {
    library: 'zope.interface',
    os_license: 'https://spdx.org/licenses/ZPL-2.1.html',
    license_name: 'ZPL 2.1',
  },
]

export default sources
